export default __webpack_public_path__ + "static/logo_songbird-bfa9be68d6f87fefe26313b2007e48db.jpg";